import { render, staticRenderFns } from "./AppReviewableSection.vue?vue&type=template&id=135cc5c2&scoped=true&"
import script from "./AppReviewableSection.vue?vue&type=script&lang=js&"
export * from "./AppReviewableSection.vue?vue&type=script&lang=js&"
import style0 from "./AppReviewableSection.vue?vue&type=style&index=0&id=135cc5c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135cc5c2",
  null
  
)

export default component.exports